export default "__VITE_PUBLIC_ASSET__51b0c1de__"